import { createContext, useContext } from "react";

import { ProductOptionFormModelContext } from "../../_shared/context/context";

import type { ProductOptionFormModelContextType } from "../../_shared/context/context";

export type ProductExistingOptionFormModelContextType = {
	onUpdate: () => void;
} & ProductOptionFormModelContextType;

export const ProductExistingRoomFormModelContext = createContext<ProductExistingOptionFormModelContextType | null>(
	null,
);

export const ProductExistingOptionFormModelContextProvider = ({
	value,
	children,
}: {
	value: ProductExistingOptionFormModelContextType;
	children: React.ReactNode;
}) => {
	return (
		<ProductExistingRoomFormModelContext.Provider value={value}>
			<ProductOptionFormModelContext.Provider value={value}>{children}</ProductOptionFormModelContext.Provider>
		</ProductExistingRoomFormModelContext.Provider>
	);
};

export const useProductExistingOptionFormModelContext = () => {
	const context = useContext(ProductExistingRoomFormModelContext);

	if (!context) {
		throw new Error(
			"useProductExistingOptionFormModelContext must be used within a ProductExistingOptionFormModelContextProvider",
		);
	}

	return {
		onUpdate: context.onUpdate,
	};
};
